"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MisMascotasCards = void 0;
var react_1 = __importStar(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var pet_card_1 = require("../pet-card");
var api_1 = require("../../lib/api");
var recoil_1 = require("recoil");
var login_1 = require("../../hooks/login");
var react_2 = require("@chakra-ui/react");
function MisMascotasCards() {
    var _a = (0, react_1.useState)(), misMascotas = _a[0], setMisMascotas = _a[1];
    var _b = (0, react_1.useState)(false), hasMascotas = _b[0], setHasMascotas = _b[1];
    var _c = (0, react_1.useState)(true), loading = _c[0], setLoading = _c[1];
    var tokenValue = (0, recoil_1.useRecoilValue)(login_1.token);
    (0, react_1.useEffect)(function () {
        (0, api_1.fetchMisMascotas)(tokenValue).then(function (mascotas) {
            if (mascotas.length == 0) {
                setHasMascotas(false);
            }
            else {
                setMisMascotas(mascotas);
                setHasMascotas(true);
            }
            setLoading(false);
        });
    }, []);
    if (loading) {
        return react_1.default.createElement(react_2.Spinner, { className: index_css_1.default.spinner });
    }
    if (!hasMascotas) {
        return react_1.default.createElement("p", null, "Aun no cargaste ninguna mascota");
    }
    return (react_1.default.createElement("div", { className: index_css_1.default.container }, misMascotas.map(function (mascota) {
        return (react_1.default.createElement(pet_card_1.PetCard, { key: mascota.id, name: mascota.name, city: mascota.city, imageUrl: mascota.imageUrl, region: mascota.region, editable: true, petId: mascota.id, contact: mascota.contact }));
    })));
}
exports.MisMascotasCards = MisMascotasCards;
